import React from 'react'

// styles
import './styles.scss'

const Divider: React.FC = () => {
  return (
    <hr className='basic-divider' />
  )
}

export default Divider